import React from "react";
import { Link } from "react-router-dom";
import Bgimg from '../../assets/images/about-story.png';

const Innerpage = () => {
    return (
    <>
        <div
            className="inner-page-hero"
            style={{ backgroundImage: `url(${Bgimg})` }}
        >
            <div className="container">
                <div className="hero-heading-title">
                    <h2>Our Story</h2>
                </div>
                {/* <ul className="bradcrumb">
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="#">Page </Link>
                    </li>
                    <li>
                        <Link to="#">About Us </Link>
                    </li>
                </ul> */}
            </div>
        </div>

    <div className="my-5 py-12 text-center "  style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems:"center"}}>
        <h2 >Your Peace of Mind. Our Purpose.</h2>
        <p style={{maxWidth: "950px", textAlign: "center", }}>The NRI Advisors was created to solve a growing problem faced by millions of NRIs.  We saw a painful gap—NRI families falling victim to misinformation, red tape, and unethical agents. That’s why we built a single, trusted platform focused only on NRIs.</p>
        <p style={{maxWidth: "950px"}}>We combine legal expertise, local presence, cultural understanding, and digital communication—so your matters are handled with urgency, integrity, and personal care.</p>
        </div>    
    </>
    )
}
export default Innerpage;